export default "__VITE_ASSET__BDizWaxw__"